<script setup lang="ts">
/**
 * Password updated (Figma `66:47166`).
 *
 * Ends on "Log in" rather than dropping the user into the app: there is no
 * auto-login after a credential change (`66:47522`).
 */
import { useI18n } from 'vue-i18n'
import { useAuthModal } from '@/features/auth/store'
import AuthButton from '@/features/auth/ui/parts/AuthButton.vue'
import AuthScreenShell from '@/features/auth/ui/parts/AuthScreenShell.vue'
import illustrationUrl from '@/assets/img/auth/illustration-password-updated.png'

const { t } = useI18n()
const authModal = useAuthModal()
</script>

<template>
  <AuthScreenShell
    centered
    :title="t('auth.password_updated.title')"
    :description="t('auth.password_updated.description')"
  >
    <template #art>
      <img
        class="fair-auth-screen__art"
        :src="illustrationUrl"
        alt=""
      >
    </template>

    <AuthButton
      :label="t('auth.password_updated.login_cta')"
      @click="authModal.showAuthModal('login')"
    />
  </AuthScreenShell>
</template>
